import { LOADING_DATA_ON_PAGE_LOAD } from "../../../modules/savedItems/constants";
import {
  CLEAR_PERSISTENT_ERRORS,
  INITIALISED
} from "../../../modules/common/constants";
import getSavedItems from "../savedLists/getSavedItems";
import { getUserIdentity } from "../../../modules/identity/actions";
import { getLoyaltyBenefits } from "../../../modules/loyalty/actions";
import { initialise as initialiseBackInStock } from "../../../modules/backInStock/actions";
import { beginAndCheckOnlineStatus } from "../savedLists/beginAndCheckOnlineStatus";

export const initialise = () => async dispatch => {
  if (!beginAndCheckOnlineStatus(dispatch)) {
    return [];
  }

  await dispatch(
    initialiseBackInStock(
      dispatch(getSavedItems()),
      dispatch(getUserIdentity()),
      dispatch(getLoyaltyBenefits())
    )
  );

  dispatch({ type: LOADING_DATA_ON_PAGE_LOAD, payload: false });
  dispatch({ type: CLEAR_PERSISTENT_ERRORS });
  dispatch({ type: INITIALISED });
};
